
  <div id="js-operator-editor" class="def-operator-child-inline" contenteditable="true"  #operatorEditor  [mention] = "itemsMention" [innerHTML]="operatorHtml"
      (copy) = "onCopyEditor($event)"
      (keydown)="onKeydownEditor($event)"
      (keyup)="onKeyupEditor($event)"
      (paste) = "onPasteEditor($event)"
    >
  </div>
